import { render, staticRenderFns } from "./EntregaLegislacao.vue?vue&type=template&id=36981f7b"
import script from "./EntregaLegislacao.vue?vue&type=script&lang=ts"
export * from "./EntregaLegislacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports